<select
  class="form-control form-control-sm fw-table-row-switch"
  [(ngModel)]="config().paginConfig.itemsPerPage"
  (change)="changeRows.emit()">
  <option *ngFor="let row of config().paginConfig.rowFields" value="{{row}}">{{row}}</option>
</select>
